/* eslint react/no-danger: 0 */
import {
  useStrings,
  useStringsWithPlaceholders,
} from "@1js/localization-components";
import {
  Image,
  type OnOpenChangeData,
  type OpenPopoverEvents,
} from "@fluentui/react-components";
import {
  TeachingPopover,
  TeachingPopoverBody,
  TeachingPopoverFooter,
  TeachingPopoverSurface,
  TeachingPopoverTitle,
} from "@fluentui/react-teaching-popover";
import React from "react";
import { useTheme } from "../../hooks/useTheme";
import {
  PopoverGotItButton,
  PopoverMessage,
  PopoverShareToTeam,
  PopoverTitle,
} from "./WorkgroupPublisherTeachingPopover.strings";

export type WorkgroupPublisherTeachingPopoverProps = {
  isEnabled: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  target: any;
  onPopoverStatus: (isOpen: boolean) => void;
};

const id = "copilotPopoverSeen-0002";

export const WorkgroupPublisherTeachingPopover: React.FC<
  WorkgroupPublisherTeachingPopoverProps
> = ({ isEnabled, target, onPopoverStatus }) => {
  const localizations = useStrings({
    PopoverTitle,
    PopoverShareToTeam,
    PopoverGotItButton,
  });
  const localizationsWithPlaceholders = useStringsWithPlaceholders({
    PopoverMessage,
  });

  const { theme } = useTheme();

  const onOpenChange = React.useCallback(
    (_: OpenPopoverEvents, data: OnOpenChangeData) => {
      if (!data.open) {
        localStorage.setItem(id, "true");
        setIsSeen(true);
        onPopoverStatus(false);
      }
    },
    [onPopoverStatus]
  );

  const onClose = React.useCallback(() => {
    localStorage.setItem(id, "true");
    setIsSeen(true);
  }, []);

  const [isSeen, setIsSeen] = React.useState<boolean>(
    localStorage.getItem(id) === "true"
  );

  if (!isEnabled || isSeen) {
    return <></>;
  }

  onPopoverStatus(true);
  return (
    <TeachingPopover
      onOpenChange={onOpenChange}
      open={true}
      withArrow={true}
      positioning={{
        target,
        position: "above",
        align: "start",
        matchTargetSize: "width",
      }}
    >
      <TeachingPopoverSurface>
        <TeachingPopoverBody
          media={
            <Image
              alt=""
              fit="cover"
              src={
                theme === "light"
                  ? "/images/WorkgroupPublish-light.webp"
                  : theme === "dark"
                    ? "/images/WorkgroupPublish-dark.webp"
                    : "/images/WorkgroupPublish-high-contrast.webp"
              }
              role="presentation"
            />
          }
        >
          <TeachingPopoverTitle>
            {localizations.PopoverTitle()}
          </TeachingPopoverTitle>
          <div
            dangerouslySetInnerHTML={{
              __html: localizationsWithPlaceholders.PopoverMessage({
                action: `<b>${localizations.PopoverShareToTeam()}</b>`,
              }),
            }}
          ></div>
        </TeachingPopoverBody>
        <TeachingPopoverFooter
          primary={localizations.PopoverGotItButton()}
          onClick={onClose}
        />
      </TeachingPopoverSurface>
    </TeachingPopover>
  );
};

WorkgroupPublisherTeachingPopover.displayName =
  "WorkgroupPublisherTeachingPopover";
